// Сумма прописью — стандартный элемент российского счёта на оплату
// («Всего к оплате: Одна тысяча девятьсот девяносто рублей 00 копеек.»).
// Реализовано без библиотек: чистая функция, только для сумм в рублях,
// подписки в проекте не превышают разумных величин (до миллиардов хватит).

const ONES_MASC = ['', 'один', 'два', 'три', 'четыре', 'пять', 'шесть', 'семь', 'восемь', 'девять'];
const ONES_FEM = ['', 'одна', 'две', 'три', 'четыре', 'пять', 'шесть', 'семь', 'восемь', 'девять'];
const TEENS = [
  'десять', 'одиннадцать', 'двенадцать', 'тринадцать', 'четырнадцать',
  'пятнадцать', 'шестнадцать', 'семнадцать', 'восемнадцать', 'девятнадцать',
];
const TENS = ['', '', 'двадцать', 'тридцать', 'сорок', 'пятьдесят', 'шестьдесят', 'семьдесят', 'восемьдесят', 'девяносто'];
const HUNDREDS = ['', 'сто', 'двести', 'триста', 'четыреста', 'пятьсот', 'шестьсот', 'семьсот', 'восемьсот', 'девятьсот'];

// forms = [один рубль, два рубля, пять рублей] — стандартное русское склонение по числу
function pluralForm(n, forms) {
  const mod100 = n % 100;
  if (mod100 >= 11 && mod100 <= 19) return forms[2];
  const mod10 = n % 10;
  if (mod10 === 1) return forms[0];
  if (mod10 >= 2 && mod10 <= 4) return forms[1];
  return forms[2];
}

// Число 0-999 словами. feminine — использовать женский род для последней цифры
// (нужно для «тысяч»: «две тысячи», а не «два тысячи»).
function groupToWords(n, feminine) {
  const words = [];
  const h = Math.floor(n / 100);
  const rest = n % 100;
  if (h) words.push(HUNDREDS[h]);
  if (rest >= 10 && rest <= 19) {
    words.push(TEENS[rest - 10]);
  } else {
    const t = Math.floor(rest / 10);
    const o = rest % 10;
    if (t) words.push(TENS[t]);
    if (o) words.push((feminine ? ONES_FEM : ONES_MASC)[o]);
  }
  return words;
}

const SCALES = [
  { forms: ['', '', ''], feminine: false }, // единицы — без названия разряда
  { forms: ['тысяча', 'тысячи', 'тысяч'], feminine: true },
  { forms: ['миллион', 'миллиона', 'миллионов'], feminine: false },
  { forms: ['миллиард', 'миллиарда', 'миллиардов'], feminine: false },
];

function integerToWords(n) {
  if (n === 0) return 'ноль';
  const groups = [];
  let rest = n;
  while (rest > 0) {
    groups.push(rest % 1000);
    rest = Math.floor(rest / 1000);
  }
  const parts = [];
  for (let i = groups.length - 1; i >= 0; i--) {
    const g = groups[i];
    if (g === 0) continue;
    const scale = SCALES[i];
    parts.push(...groupToWords(g, scale.feminine));
    if (i > 0) parts.push(pluralForm(g, scale.forms));
  }
  return parts.join(' ');
}

const capitalize = (s) => (s ? s[0].toUpperCase() + s.slice(1) : s);

// amount — число (может быть с копейками, напр. 1592.5) -> строка вида
// «Одна тысяча пятьсот девяносто два рубля 50 копеек»
export function amountToWordsRu(amount) {
  const rounded = Math.round((Number(amount) || 0) * 100);
  const rubles = Math.floor(rounded / 100);
  const kopecks = rounded % 100;
  const rublesWords = capitalize(integerToWords(rubles));
  const rublesLabel = pluralForm(rubles, ['рубль', 'рубля', 'рублей']);
  const kopecksLabel = pluralForm(kopecks, ['копейка', 'копейки', 'копеек']);
  const kopecksStr = String(kopecks).padStart(2, '0');
  return `${rublesWords} ${rublesLabel} ${kopecksStr} ${kopecksLabel}`;
}

export default amountToWordsRu;
